// angular
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef, OnInit,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {IonContent, ModalController, Platform} from '@ionic/angular';
import {NgModel} from '@angular/forms';
// stores
import {RestaurantStore} from 'src/app/core/stores/restaurant.store';
import {CartStore} from 'src/app/core/stores/cart.store';
import {PaymentStore} from '../../../core/stores/payment.store';
// rxjs
import {from, fromEvent, Observable, of, Subject} from 'rxjs';
import {auditTime, catchError, concatMap, filter, mapTo, mergeMap, takeUntil, tap, toArray, distinctUntilChanged} from 'rxjs/operators';
// services
import {RouteService} from '../../../core/services/route.service';
// models
import {
  CatalogData,
  Country,
  Group,
  Restaurant,
  RestaurantCategory,
  RestaurantProduct,
  Taxes,
  WorkDay
} from 'src/app/core/models/restaurant.model';
import {MenuItemForPayment, ProductCollapseState} from 'src/app/core/models/cart-item.model';
// services

import {Order} from '../../../core/models/payment-item.model';
import {OrderApiService} from '../../../core/services/order.api.service';
import {ItemValidateService} from '../../../core/services/item-validate.service';
import {ProductModalComponent} from '../../../shared/components/product-modal/product-modal.component';
import {FormatDataService} from '../../../core/services/format-data.service';
import {FormatStyleService} from '../../../core/services/format-style.service';
import {PaymentService} from '../../../core/services/payment.service';
import { ItemService } from '../../../core/services/item.service';
import { CustomerStore } from 'src/app/core/stores/customer.store';
import { StorageService } from 'src/app/core/services/storage.service';
import { STORAGE_CUSTOMER_DATA } from 'src/app/core/constants';
import { FavoriteProductService } from 'src/app/core/services/favorite-product.service';

@Component({
  selector: 'app-restaurant-group',
  templateUrl: './restaurant-group.component.html',
  styleUrls: ['./restaurant-group.component.scss']
})
export class RestaurantGroupComponent implements AfterViewInit {

  @ViewChild(IonContent, {static: true}) content: IonContent;
  @ViewChild(NgModel, {static: true}) customAmountInput: NgModel;
  @ViewChild('categoryTabContainer', {static: false, read: ElementRef}) categoryTabContainer: ElementRef;
  @ViewChild('categoryWrapper', {static: false, read: ElementRef}) categoryWrapper: ElementRef;
  @ViewChild('rightButton', {static: false, read: ElementRef}) rightButton: ElementRef;
  @ViewChildren('categoryTab', {read: ElementRef}) categoryTabList: QueryList<ElementRef>;
  @ViewChildren('category', {read: ElementRef}) categories: QueryList<ElementRef>;

  public get categoriesArray() {
    return this.categories.toArray();
  }

  public get categoryTabArray() {
    return this.categoryTabList.toArray();
  }

  public get categoriesTop() {
    return this.categories.map((category) => category.nativeElement.offsetTop);
  }

  public get categoryTabListLeft() {
    return this.categoryTabList.map((category) => category.nativeElement.offsetLeft);
  }

  private destroyed$ = new Subject<void>();
  private _activeItemIndex = 0;

  public groupId: string;
  public group: Group;
  public restaurants: Restaurant[] = [];
  public restaurantsFilteredWorkHours: WorkDay[][] = [];

  public addItemQueue = [];
  public taxes: Taxes[];

  public isRestaurant = true;
  public isTaxes = false;

  public selectedProduct: RestaurantProduct;
  public selectedProductRestaurant: Restaurant;
  public filteredProductList: RestaurantProduct[][] = [];

  public isShowCategoryTabsRightArrow = false;
  public isShowRestaurantClosedModal = true;
  public isShowRestaurantAgeGateModal = true;
  public isShowRestaurantTabModal = false;
  public isShowProductModal = false;
  public isClickOnLastTab = false;
  public isScrollPositionTop = true;
  public isAlcoholHidden = false;
  public isWindmill = false;

  public fromPayment = false;
  public ordersIsEmpty: boolean;
  public restaurantCategories: RestaurantCategory[] = [];
  public orderBotUserId: string;
  public favoriteItems: string[] = [];
  public restaurantProducts: RestaurantProduct[] = [];

  public get isMobile(): boolean {
    return this.platform.is('mobile') || this.platform.width() < 600;
  }

  public get showCheckout(): boolean {
    return this.isMobile && this.cartStore.items.length > 0;
  }

  public get placeCategoryTabsInHeader(): boolean {
    return this.isMobile && !this.isScrollPositionTop;
  }

  public get showCategoryTabsLeftArrow(): boolean {
    return this.categoryWrapper && this.categoryWrapper.nativeElement && this.categoryWrapper.nativeElement.scrollLeft > 10;
  }

  public get showCategoryTabsRightArrow(): boolean {
    return this.isShowCategoryTabsRightArrow && this.categoryWrapper.nativeElement.scrollWidth - 10 >
      this.categoryWrapper.nativeElement.clientWidth + this.categoryWrapper.nativeElement.scrollLeft;
  }

  public get activeItemIndex(): number {
    return this._activeItemIndex;
  }

  public set activeItemIndex(newIndex: number) {
    if (this._activeItemIndex !== newIndex) {
      this.scrollToCategoryTab(newIndex);
    }
    this._activeItemIndex = newIndex;
  }

  public get isRestaurantClosed(): boolean {
    if (this.selectedProductRestaurant) {
      if (!this.selectedProductRestaurant.isAcceptingOrders || !this.selectedProductRestaurant.isMobileEnabled) {
        return true;
      }
    }
    return false;
  }

  public get isRestaurantHaveEnabledWorkDays(): boolean {
    return !!this.selectedProductRestaurant.hoursOfOperation.find((day) => day.enable === true);
  }

  public get isShowTabModal(): boolean {
    if (!this.restaurants) return false;
    return (this.cartStore.showTabModal && !this.isShowAgeGateModal) || this.cartStore.tabClosedSuccessful;
  }

  public get isShowAgeGateModal(): boolean {
    if (!this.restaurants) return false;

    return this.restaurants.find((restaurant) => restaurant.showAgeGate === true)
      && this.isShowRestaurantAgeGateModal;
  }

  public get isShowClosedModal(): boolean {
    if (!this.restaurants) return false;

    return (!this.restaurants.find((restaurant) => restaurant.isAcceptingOrders === true)
      || !this.restaurants.find((restaurant) => restaurant.isMobileEnabled === true))
      && this.isShowRestaurantClosedModal
      && !this.isShowAgeGateModal;
  }

  constructor(
    public restaurantStore: RestaurantStore,
    public cartStore: CartStore,
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title,
    private platform: Platform,
    private paymentStore: PaymentStore,
    private modalController: ModalController,
    private routeService: RouteService,
    private orderApiService: OrderApiService,
    private paymentService: PaymentService,
    private itemValidateService: ItemValidateService,
    private formatDataService: FormatDataService,
    private formatStyleService: FormatStyleService,
    private cdr: ChangeDetectorRef,
    private itemService: ItemService,
    private customerStore: CustomerStore,
    private storageService: StorageService,
    private favoriteProductService: FavoriteProductService
  ) {
  }

  ionViewWillEnter() {
    this.filteredProductList = [];
    this.restaurantCategories = [];
    this.restaurantProducts = [];
    sessionStorage.removeItem('groupId');
    this.restaurantStore.groupIdForRedirect = null;
    if (this.restaurantStore.isGoToCheckout) {
      this.restaurantStore.clearCurCategoriesAndCurProducts();
    }
    this.restaurantStore.isGoToCheckout = false;
    this.paymentService.getCustomerOpenedTab();
    this.groupId = this.routeService.getGroupId();
    this.isWindmill = this.groupId === 'windmill';

    this.route.params.subscribe(params => {
      if (params) {
        this.restaurantStore.checkRouteContainsTableNumber(params.tableNumber);
      }
      this.restaurantStore.checkRouteContainsTimeRangeOptions();
      this.restaurantStore.checkRouteContainsFullfillmentOptions();
      this.restaurantStore.checkCustomNumber();
    });

    this.restaurantStore.checkRoutQueryParams();

    this.restaurantStore.bootstrapRestaurants(this.groupId, true);
    this.initListeners();
    this.getGroup();
    this.getRestaurants();
    this.content.ionScroll.pipe(auditTime(200)).subscribe((event) => this.trackScroll(event));
    this.restaurantStore.filteredWorkHours$
      .pipe(filter(Boolean))
      .subscribe((result: any) => {
        if (result) {
          for (const restaurant of this.restaurants) {
            this.restaurantsFilteredWorkHours.push(this.formatDataService.formatIfStoreContinueWorking(result[restaurant.locationId]));
          }
        }
      });
  }

  ngAfterViewInit(): void {
    fromEvent(this.categoryWrapper.nativeElement, 'scroll').pipe(auditTime(200))
      .subscribe(() => {
        this.trackCategoryTabsScroll();
      });
  }

  ionViewWillLeave() {
    this.destroyed$.next();
    if (!this.restaurantStore.isGoToCheckout) {
      this.restaurantStore.clearCurCategoriesAndCurProducts();
    }
  }

  public initListeners(): void {
    this.restaurantStore.updateGroupInfo$
      .subscribe((value: boolean) => {
        if (value) {
          this.setGroupInfo();
          if (this.cartStore.groupTab && this.cartStore.groupTab.rounds.length === 0) {
            this.paymentService.checkCustomerOpenTab();
          }
        }
      });
  }

  public closeTabModal(): void {
    this.cartStore.showTabModal = false;
  }

  public async scrollToCategory(index: number, isLast: boolean): Promise<void> {
    this.isClickOnLastTab = isLast;
    this.activeItemIndex = index;
    if (!this.categoriesArray[index]) {
      return;
    }

    await this.content.scrollToPoint(0, this.categoriesArray[index].nativeElement.offsetTop, 300);
  }

  public trackCategoryTabsScroll() {
    this.cdr.markForCheck();
  }

  public async trackScroll(event): Promise<void> {
    const element = await this.content.getScrollElement();

    const offsetForHeader = this.isScrollPositionTop ? 100 : 0;
    const isHideScroll = element.offsetHeight === element.scrollHeight;
    this.isScrollPositionTop = event.detail.scrollTop <= offsetForHeader && !isHideScroll;

    if (this.isClickOnLastTab || Math.ceil(element.scrollTop + element.offsetHeight) >= element.scrollHeight) {
      this.activeItemIndex = this.categoriesTop.length - 1;
      if (this.restaurantCategories[this.activeItemIndex]?.locationId === this.restaurants[this.restaurants.length - 1]?.locationId) {
        this.restaurantStore.activeLocationIndex = this.restaurants.length - 1;
      }
      return;
    }

    const {scrollTop} = event.detail;
    const offset = element.offsetHeight / 3;
    this.activeItemIndex = this.categoriesTop.findIndex((categoryTop, index, categoriesTop) => {
      const nextCategoryTop = categoriesTop[index + 1];
      const isLastItem = index === categoriesTop.length - 1;
      const insideScrolling = ((categoryTop - offset) <= scrollTop && (nextCategoryTop - offset) > scrollTop);
      return insideScrolling || isLastItem;
    });
    const activeCategoryLocation = this.restaurants.find((restaurant) => this.restaurantCategories[this.activeItemIndex].locationId === restaurant.locationId);
    this.restaurantStore.activeLocationIndex = this.restaurants.indexOf(activeCategoryLocation);
  }

  public scrollToPreviousCategoryTabs() {
    const nextScrollPosition = this.categoryWrapper.nativeElement.scrollLeft;
    const scrollToIndex = this.categoryTabListLeft.findIndex((categoryTabLeft, index) => {
      if (index !== 0) {
        const previousCategoryTabLeft = this.categoryTabListLeft[index - 1];
        return previousCategoryTabLeft <= nextScrollPosition && nextScrollPosition <= categoryTabLeft;
      }
    });
    this.categoryTabArray[scrollToIndex].nativeElement.scrollIntoView({inline: 'end', behavior: 'smooth'});
  }

  public scrollToNextCategoryTabs() {
    const nextScrollPosition = this.categoryWrapper.nativeElement.clientWidth + this.categoryWrapper.nativeElement.scrollLeft;
    const scrollToIndex = this.categoryTabListLeft.findIndex((categoryTabLeft, index) => {
      if (index !== this.categoryTabListLeft.length - 1) {
        const nextCategoryTabLeft = this.categoryTabListLeft[index + 1];
        return categoryTabLeft <= nextScrollPosition && nextScrollPosition <= nextCategoryTabLeft;
      } else {
        return true;
      }
    });
    this.categoryTabArray[scrollToIndex].nativeElement.scrollIntoView({inline: 'start', behavior: 'smooth'});
  }

  public changeLastTabFlag(): void {
    this.isClickOnLastTab = false;
  }

  private getGroup(): void {
    this.restaurantStore.getGroupById(this.groupId)
      .pipe(filter(Boolean))
      .subscribe((group: Group) => {
        this.group = group;
        this.restaurantStore.group = group;
        this.setGroupInfo();
        if (!group.combineGroupLocations && !this.restaurantStore.selectedLocationInGroup) {
          this.group = new Group();
          this.restaurantStore.group = new Group();
          this.router.navigate(['locations', 'groups', this.groupId]).catch(error => console.error(error));
        }
      });
  }

  private getRestaurants(): void {
    this.restaurantStore.getRestaurants()
      .pipe(
        takeUntil(this.destroyed$),
        filter(Boolean),
        mergeMap((restaurants: Restaurant[]) => {
          if (restaurants.length !== 0) {
            this.restaurants = this.sortBySelectedLocationInGroup(restaurants);
            this.isTaxes = false;
            return from(this.restaurants).pipe(
              mergeMap(restaurant => this.getRestaurantsCatalogData(restaurant.locationId, restaurant.merchantId)),
              toArray()
            );
          } else {
            return of([]);
          }
        })
      )
      .subscribe(() => {
        if(this.restaurantCategories.length && this.restaurantProducts.length){
          this.associateProductsWithCategories()
          // commenting out favorite items for groups for now
          // const favoriteCategory = new RestaurantCategory('Favorites', 'Favorites');
          // favoriteCategory.items = [];
          // this.restaurantCategories.unshift(favoriteCategory)
          // this.updateFavoriteProducts()
        }
        this.restaurantStore.loadItemsInProgress = false;
        for (const restaurant of this.restaurants) {
          this.generateWorkDaysForRestaurants(restaurant.locationId);
        }
      });
  }

  private sortBySelectedLocationInGroup(restaurants: Restaurant[]): Restaurant[] {
    const clonedRestaurants = this.formatDataService.deepCopy<Restaurant[]>(restaurants);
    const index = clonedRestaurants.findIndex(el => el.locationId === this.restaurantStore.selectedLocationInGroup);
    if (index && index !== -1) {
      clonedRestaurants.unshift(...clonedRestaurants.splice(index, 1));
    }
    return clonedRestaurants;
  }

  private setGroupInfo(): void {
    if (this.group) {
      localStorage.setItem('groupId', this.groupId);
      this.cartStore.kyooFee = this.group.kyooFee;
      this.cartStore.additionalKyooFee = this.group.additionalKyooFee;
      this.cartStore.autoGratuityPercent = this.group.autoGratuityPercent;
      this.cartStore.tippingEnabled = this.group.tippingEnabled;
      this.titleService.setTitle(this.group.displayName);
      this.restaurantStore.isGroup = true;
      this.restaurantStore.restaurantCountryInfo = Country.getCountryByName(this.group.country);
      this.formatStyleService.setGlobalBrandColor(this.group.brandColor);
      this.formatStyleService.setGlobalBackgroundColor(this.group.backgroundColor);
      this.formatStyleService.setGlobalBorderColor(this.group.borderColor);
      this.formatStyleService.setGlobalPrimaryTextColor(this.group.primaryTextColor);
      this.formatStyleService.setGlobalSecondaryTextColor(this.group.secondaryTextColor);
      this.restaurantStore.updateGroupInfo = false;
      if (this.cartStore.groupTab) {
        this.paymentService.setFeeForGroupTabs();
      }
    }
  }

  private generateWorkDaysForRestaurants(locationId: string) {
    this.restaurantStore.filteredWorkHours$
      .pipe(filter(Boolean))
      .subscribe((result: any) => {
        if (result[locationId]) {
          return this.formatDataService.formatIfStoreContinueWorking(result[locationId]);
        }
      });
  }

  private getRestaurantsCatalogData(locationId: string, merchantId: string): Observable<void> {
    return this.restaurantStore.checkIsCatalogUploaded(merchantId)
      .pipe(
        concatMap((result: any) =>
          this.restaurantStore.getGroupCatalogData(locationId, result.uploaded, merchantId).pipe(
            takeUntil(this.destroyed$),
            filter(Boolean),
            concatMap((response: CatalogData) => {
              response.taxes.length === 1 && response.taxes[0].id === locationId ? this.taxes = [] : this.taxes = response.taxes;
              this.restaurantStore.categoryLoadedQueue = [...response.categories];
              this.restaurantStore.loadItemsInProgress = true;

              const restaurantOrderMap = this.restaurants.reduce((acc, restaurant, index) => {
                acc[restaurant.locationId] = index;
                return acc;
              }, {} as { [key: string]: number });

              const insertionIndex = restaurantOrderMap[locationId];

              if (insertionIndex !== undefined) {
                const categoriesBefore = this.restaurantCategories.filter(
                  category => restaurantOrderMap[category.locationId] < insertionIndex
                );
                const categoriesAfter = this.restaurantCategories.filter(
                  category => restaurantOrderMap[category.locationId] > insertionIndex
                );

                this.restaurantCategories = [
                  ...categoriesBefore,
                  ...response.categories,
                  ...categoriesAfter
                ];
              } else {
                this.restaurantCategories = this.restaurantCategories.concat(response.categories);
              }

              if(result.uploaded){
                return this.loadAllCategory(locationId,merchantId,true).pipe(
                  catchError(err => {
                    return this.loadCategoriesOneByOne(response.categories, locationId, merchantId, result.uploaded);
                  })
                );
              } else{
                return this.loadCategoriesOneByOne(response.categories, locationId, merchantId, result.uploaded);
              }
            })
          )
        )
      );
  }

  private loadCategoriesOneByOne(categories: RestaurantCategory[], locationId: string, merchantId: string, isCatalogUploaded: boolean): Observable<void> {
    return from(categories).pipe(
      concatMap(category => this.loadNextCategory(locationId, merchantId, category, isCatalogUploaded))
    );
  }

  private loadNextCategory(locationId: string, merchantId: string, category: RestaurantCategory, isCatalogUploaded: boolean): Observable<void> {
    const location = this.findLocationById(locationId);
    return this.restaurantStore.getProductsByCategoryId(locationId, isCatalogUploaded, false, category, merchantId)
      .pipe(
        tap((products: RestaurantProduct[]) => {
          this.restaurantProducts = [...this.restaurantProducts, ...products];
          this.isTaxes = true;
          const allVariationIds = this.restaurantStore.getCategoryVariationIds(products);
          this.filterProducts(products);
          const variationIdsWithInventory = this.restaurantStore.getUseInventoryItems(products);
          if (location.enforceInventory && allVariationIds.length > 0) {
            this.loadNextVariationsInventory(locationId, allVariationIds, location.merchantId);
          } else if (variationIdsWithInventory.length > 0) {
            this.loadNextVariationsInventory(locationId, variationIdsWithInventory, location.merchantId);
          }
        }),
        mapTo(void 0)
      );
  }

  private loadAllCategory(locationId: string, merchantId: string, isCatalogUploaded: boolean): Observable<void> {
    const location = this.findLocationById(locationId);
    return this.restaurantStore.getAllProductsByLocationId(locationId,true,false,location.merchantId)
      .pipe(
        tap((products: RestaurantProduct[]) => {
          this.restaurantProducts = [...this.restaurantProducts, ...products];
          this.isTaxes = true;
          const allVariationIds = this.restaurantStore.getCategoryVariationIds(products);
          this.filterProducts(products);
          const variationIdsWithInventory = this.restaurantStore.getUseInventoryItems(products);
          if (location.enforceInventory && allVariationIds.length > 0) {
            this.loadNextVariationsInventory(locationId, allVariationIds, location.merchantId);
          } else if (variationIdsWithInventory.length > 0) {
            this.loadNextVariationsInventory(locationId, variationIdsWithInventory, location.merchantId);
          }
        }),
        mapTo(void 0))
  }

  private loadNextVariationsInventory(locationId: string, variationIdList: string[], merchantId?: string) {
    for (let i = 0; i < variationIdList.length; i += 100) {
      this.restaurantStore.getProductsInventory(locationId, variationIdList.slice(i, i + 100), merchantId).subscribe();
    }
  }

  public showProductModal(product: RestaurantProduct) {
    const location = this.findLocationById(product.locationId);
    this.selectedProduct = product;
    this.selectedProductRestaurant = location;
    this.getRestaurantAvailableStatus(this.selectedProductRestaurant);
    if (!this.isMobile) {
      this.isShowProductModal = true;
    } else if (!this.restaurantStore.openItemCardInProgress) {
      this.restaurantStore.openItemCardInProgress = true;
      this.createModal();
    }
  }

  async createModal() {
    const modal = await this.modalController.create({
      component: ProductModalComponent,
      componentProps: {
        defaultProduct: this.selectedProduct,
        restaurant: this.selectedProductRestaurant,
        locationId: this.selectedProductRestaurant.locationId,
        taxes: this.taxes,
        isClosed: this.isRestaurantClosed,
        allowScheduledPickups: this.selectedProductRestaurant.allowScheduledPickups,
        isMobileEnabled: this.selectedProductRestaurant.isMobileEnabled,
        isModal: false,
        enforceInventory: this.selectedProductRestaurant.enforceInventory,
        hoursOfOperation: this.selectedProductRestaurant.hoursOfOperation,
        currencySign: this.restaurantStore.restaurantCountryInfo.currencySign,
        isRestaurantHaveEnabledWorkDays: this.isRestaurantHaveEnabledWorkDays
      }
    });

    modal.onDidDismiss().then(data => {
      const item = data['data'] ? data['data'].cartProduct : null;
      this.restaurantStore.openItemCardInProgress = false;
      if (item != null) {
        this.onAddItemToCart(item);
      }
    });
    await modal.present();
  }

  public filterProducts(products: RestaurantProduct[]) {
    const newCategory: any = [];
    if (products.length === 0) {
      return;
    }
    const restaurant = this.findLocationById(products[0].locationId);
    for (const item of products) {
      let showItem = true;
      if (restaurant &&
        (restaurant.isAcceptingOrders && !restaurant.allowScheduledPickups && !restaurant.showAllTimeRestrictedItems && !this.validateItem(item)) ||
        (!restaurant.showAllFulfillmentRestrictedItems && !this.validateItemAvailableFulfillments(item))) {
        showItem = false;
      }
      if (showItem) {
        newCategory.push(item);
      }
    }
    if (newCategory.length > 0) {
      if (this.isAlcoholHidden && restaurant && restaurant.allowScheduledPickups && this.restaurantStore.filterItemsInCategory(newCategory, this.isAlcoholHidden).length > 0) {
        const items = this.restaurantStore.filterItemsInCategory(newCategory, this.isAlcoholHidden);
        this.filteredProductList.push(items);
      } else {
        newCategory.sort((a, b) => {
          const aSold = this.itemService.isSoldOut(a, restaurant) ? 1 : 0;
          const bSold = this.itemService.isSoldOut(b, restaurant) ? 1 : 0;
          return aSold - bSold;
        });
        this.filteredProductList.push(newCategory);
      }
    }
  }

  private getRestaurantAvailableStatus(restaurant: Restaurant): string[] {
    const {isCurbsideEnabled, isTablesideEnabled, isPickupEnabled} = restaurant.availableStatus;
    if (this.restaurantStore.fulfillmentParams != null && this.restaurantStore.fulfillmentParams.length > 0 && restaurant.isMobileEnabled) {
      const fulfillmentStatus = {'pickup': isPickupEnabled, 'curbside': isCurbsideEnabled, 'tableside': isTablesideEnabled};
      const activeFulfillments = this.restaurantStore.fulfillmentParams.filter(param => fulfillmentStatus[param]);
      restaurant.isMobileEnabled = activeFulfillments.length > 0;
    }
    return this.restaurantStore.getRestaurantFulfillment(restaurant, this.restaurantStore.fulfillmentParams);
  }

  private validateItem(item: RestaurantProduct): boolean {
    const isValidLeadTime = this.validateItemLeadTime(item);
    const isValidWeekDay = this.validateItemAvailableDays(item);

    return isValidLeadTime && isValidWeekDay;
  }

  private validateItemLeadTime(item: RestaurantProduct): boolean {
    const productValidVariations: boolean[] = [];
    const location = this.findLocationById(item.locationId);
    for (const variation of item.variations) {
      if (variation == null) {
        return;
      }
      if (variation.isLeadTimesEnabled) {
        productValidVariations.push(this.itemValidateService.validLeadTime(variation, location.hoursOfOperation));
      } else {
        productValidVariations.push(true);
      }
    }

    return productValidVariations.filter(variation => variation === true).length > 0;
  }

  private validateItemAvailableDays(item: RestaurantProduct): boolean {
    const productValidVariations: boolean[] = [];
    for (const variation of item.variations) {
      if (variation.isDailyRestrictionEnabled) {
        productValidVariations.push(this.itemValidateService.validDayRestriction(variation));
      } else {
        productValidVariations.push(true);
      }
    }

    return productValidVariations.filter(variation => variation === true).length > 0;
  }

  private validateItemAvailableFulfillments(item: RestaurantProduct): boolean {
    const productValidVariations: boolean[] = [];
    const location = this.findLocationById(item.locationId);
    for (const variation of item.variations) {
      if (variation.isFulfillmentRestrictionEnabled) {
        productValidVariations.push(this.itemValidateService.validFulfillments(variation, this.getRestaurantAvailableStatus(location)));
      } else {
        productValidVariations.push(true);
      }
    }

    return productValidVariations.filter(variation => variation === true).length > 0;
  }

  public isProductSold(product: RestaurantProduct): boolean {
    const variationsAvailable = [];
    const location = this.findLocationById(product.locationId);
    for (const variation of product.variations) {
      if (variation.trackInventory && (location.enforceInventory || variation.useInventory)) {
        if (variation.quantityRemaining > 0) {
          variationsAvailable.push(variation);
        }
      } else {
        return false;
      }
    }
    return variationsAvailable.length === 0;
  }

  public showCategoryItems(category: RestaurantCategory): void {
    category.hideItems = !category.hideItems;
  }

  public isCategoryProductHidden(product: RestaurantProduct, categories: RestaurantCategory[]): boolean {
    if (!categories || !categories.length) {
      return false;
    }
    const productCategoryId = product.categoryId;
    const productLocationId = product.locationId;
    return categories?.find( (category) => category.id === productCategoryId && category.locationId === productLocationId)?.hideItems;
  }

  public productCollapseState(product: RestaurantProduct, categories: RestaurantCategory[]): ProductCollapseState {
    if (!categories || !categories.length) {
      return ProductCollapseState.SHOW;
    }
    return this.isCategoryProductHidden(product, categories) ? ProductCollapseState.HIDE : ProductCollapseState.SHOW;
  }

  public goToCheckout() {
    this.restaurantStore.isGoToCheckout = true;
    if (this.cartStore.countOrderMapRestaurants === 1 && !this.cartStore.groupTab) {
      this.restaurantStore.isGroup = false;
      const restaurant = this.findLocationById(Object.keys(this.cartStore.orderMap)[0]);
      sessionStorage.setItem('locationId', restaurant.locationId);
      if (restaurant.availableStatus) {
        this.restaurantStore.setRestaurantAvailableStatus(restaurant.availableStatus);
        this.restaurantStore.setRestaurantIsAvailable(true);
      } else {
        this.restaurantStore.setRestaurantIsAvailable(false);
      }
      const url = this.routeService.createLocationUrl(restaurant.merchantId, restaurant.locationId);
      this.router.navigate([url, 'checkout']).catch(error => console.error(error));
    } else {
      const groupUrl = this.routeService.getGroupUrl();
      this.router.navigate([groupUrl, 'checkout']).catch(error => console.error(error));
    }
  }

  public closeProductModal(): void {
    this.isShowProductModal = false;
    this.selectedProduct = null;
    this.selectedProductRestaurant = null;
  }

  public closeAgeGateModal(): void {
    this.isShowRestaurantAgeGateModal = false;
  }

  public scrollToRestaurant(event: number): void {
    const location = this.restaurants[event];
    for (const [index, category] of this.restaurantCategories.entries()) {
      if (category.locationId === location.locationId) {
        this.scrollToCategory(index, false);
        break;
      }
    }
  }

  public onAddItemToCart(item: MenuItemForPayment): void {
    if (item == null) {
      return;
    }
    if (!this.cartStore.updateCartInProgress) {
      this.cartStore.addItemToCart(item);
      this.cartStore.updateCartInProgress = true;
      const order = this.orderApiService.createOrder(item.locationId);
      if (!this.cartStore.orderMap[item.locationId]) {
        this.sendOrder(item.locationId, order);
      } else {
        this.calculateOrder(item.locationId, order);
      }
      if (this.addItemQueue.length === 0) {
        this.closeProductModal();
      }
    } else {
      this.addItemQueue.push(item);
      this.closeProductModal();
    }
  }

  private sendOrder(locationId: string, order: Order): void {
    order.applied_taxes = this.taxes.map(tax => tax.id);
    const merchantUrl = this.createMerchantUrl(locationId);
    this.orderApiService.sendOrder(locationId, order, merchantUrl)
      .subscribe(({id, total_money, discounts, taxes}: any) => {
        const amount = total_money.amount - this.cartStore.taxesSum(taxes);
        this.cartStore.orderMap[locationId] = {
          id,
          order,
          amount,
          discounts,
          taxes,
          loyaltyPoints: 0,
          isUpdated: false,
          isSubmitted: false,
          isPaid: false
        };
        this.updatingComplete();
        this.addNextItem();
      });
  }

  private calculateOrder(locationId: string, order: Order): void {
    const merchantUrl = this.createMerchantUrl(locationId);
    const orderMap = this.cartStore.orderMap[locationId];
    this.orderApiService.calculateOrder(locationId, order, merchantUrl)
      .subscribe(({total_money, taxes, discounts, accumulated_loyalty_points, line_items}: any) => {
        const totalPrice = total_money.amount - this.cartStore.taxesSum(taxes);
        this.cartStore.updateOrderMapData(locationId, order, totalPrice, taxes, discounts, accumulated_loyalty_points, line_items);
        this.updatingComplete();
        this.addNextItem();
      }, () => this.addNextItem());
  }

  private addNextItem() {
    this.cartStore.updateCartInProgress = false;
    if (this.addItemQueue.length !== 0) {
      this.onAddItemToCart(this.addItemQueue[0]);
      this.addItemQueue.shift();
    }
  }

  public closeRestaurantClosedModal() {
    this.isShowRestaurantClosedModal = false;
  }

  private scrollToCategoryTab(categoryIndex: number): void {
    if (this.categoryTabArray[categoryIndex]) {
      this.categoryTabArray[categoryIndex].nativeElement.scrollIntoView({inline: 'center'});
    }
  }

  private findLocationById(locationId: string): Restaurant {
    return this.restaurants.find((restaurant) => restaurant.locationId === locationId);
  }

  private createMerchantUrl(locationId: string): string {
    return `merchants/${this.findLocationById(locationId).merchantId}`;
  }

  private updatingComplete(): void {
    this.paymentStore.isWaitingUpdate = false;
    this.cartStore.updateCartInProgress = false;
  }

  private setCategoryToRestaurant(products: RestaurantProduct[], category: RestaurantCategory): void {
    this.restaurantCategories.map(restCategory => {
      if (restCategory.id === category?.id && restCategory.locationId == category.locationId) {
        restCategory.items = products;
      }
    });
  }

  public isFavorite(product:RestaurantProduct): boolean {
    return this.favoriteProductService.isFavorite(product,this.favoriteItems)
  }

  private findFavoriteItems(categories:RestaurantCategory[], favoriteItems:string[]) {
    const foundFavorites = new Set<any>();
    function search(categoryList: RestaurantCategory[]) {
      for (const category of categoryList) {
        for (const item of category.items) {
          if (favoriteItems.includes(item.info.id)) {
            foundFavorites.add(item);
          }
        }
        if (category.subCategories && category.subCategories.length > 0) {
          search(category.subCategories);
        }
      }
    }
    search(categories);
    return foundFavorites;
  }

  private updateFavoriteProducts(load?:boolean) {
    if(this.restaurantCategories.length && this.restaurantCategories[0].id == 'Favorites'){
      const items = Array.from(this.findFavoriteItems(this.restaurantCategories, this.favoriteItems))
      this.restaurantCategories[0].items = items
      if(!items.length){
        this.restaurantCategories[0].hideItems = true
      } else {
        this.restaurantCategories[0].hideItems = false
      }
    }
  }

  private associateProductsWithCategories(): void {
    const productsByCategory = this.restaurantProducts.reduce((acc, product) => {
      if (product.categoryId && product.locationId) {
        const key = `${product.locationId}_${product.categoryId}`;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(product);
      }
      return acc;
    }, {} as { [key: string]: RestaurantProduct[] });

    this.restaurantCategories.forEach(category => {
      if (category.locationId) {
        const key = `${category.locationId}_${category.id}`;
        if (productsByCategory[key]) {
          category.items = productsByCategory[key];
        }
      }
    });
  }

  private async setupCustomerFavoriteItems() {
    const customer = await this.storageService.get(STORAGE_CUSTOMER_DATA);
    if(customer && customer.orderBotUserId){
      this.orderBotUserId = customer.orderBotUserId
      this.customerStore.loadFavoriteItems(this.orderBotUserId)
    }
    this.customerStore.favoriteItems$
      .pipe(
        distinctUntilChanged()
      )
      .subscribe((items) => {
        this.favoriteItems = items;
        if (this.filteredProductList && this.filteredProductList.length) {
          this.updateFavoriteProducts();
        }
      });
  }

  public isHideCategory(category: RestaurantCategory): boolean {
    if (category.subCategories.length) {
       return category.subCategories.every(subCategories => !subCategories.items.length) && !category.items.length;
    }
    return !category.items.length;
  }
}
